"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from "react";
import RadioButton from "./RadioButton";
export interface RadioSelectBoxItem {
  id: string;
  label: string;
  value: string;
}
interface SelectBoxProps {
  title: string;
  items: RadioSelectBoxItem[];
  selectedItem?: string;
  onChange?: (selected: string) => void;
}
export default function RadioSelectBox(t0) {
  const $ = _c(26);
  const {
    title,
    items,
    selectedItem: initialSelected,
    onChange
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initialSelected);
  let t1;
  if ($[0] !== onChange) {
    t1 = value => {
      setSelectedItem(value);
      onChange?.(value);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSelect = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggleOpen = t2;
  let t3;
  if ($[3] !== title) {
    t3 = <span>{title}</span>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== items || $[6] !== selectedItem) {
    t4 = selectedItem && <span className="bg-primary text-white px-2 py-0.5 rounded text-xs">{items.find(i => i.value === selectedItem)?.label}</span>;
    $[5] = items;
    $[6] = selectedItem;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `w-3 h-3 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2" fill="none" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <svg className={t5} viewBox="0 0 12 7">{t6}</svg>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <span className="flex items-center gap-1">{t4}{t7}</span>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t3 || $[15] !== t8) {
    t9 = <div className="flex justify-between items-center px-3 py-2 cursor-pointer" onClick={toggleOpen}>{t3}{t8}</div>;
    $[14] = t3;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleSelect || $[18] !== isOpen || $[19] !== items || $[20] !== selectedItem || $[21] !== title) {
    t10 = isOpen && <div className="w-full bg-transparent rounded-md mt-2 shadow-md p-2"><div className="flex flex-col gap-2">{items.map(item => <RadioButton id={item.id} key={item.id} label={item.label} name={title} checked={selectedItem === item.value} onChange={() => handleSelect(item.value)} />)}</div></div>;
    $[17] = handleSelect;
    $[18] = isOpen;
    $[19] = items;
    $[20] = selectedItem;
    $[21] = title;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <div className="w-full border rounded-md shadow-sm relative">{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
function _temp(prev) {
  return !prev;
}